import React from "react";
import { Input } from "antd";
import MagicIcon from "../../../../Icons/MagicIcon.js";
import { css, keyframes } from "@emotion/css";

const colorChange = keyframes`
  0% { border-color: #ffbb96; }
  33% { border-color: #96ffbb; }
  66% { border-color: #bb96ff; }
  100% { border-color: #ffbb96; }
`;

const styles = {
  inputContainer: css`
    width: 100%;
    padding: 32px;
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
  `,
  inputWrapper: css`
    position: relative;
    width: 100%;
    max-width: 480px;
  `,
  magicIcon: css`
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #ffbb96;
    z-index: 1;
  `,
  inputField: css`
    width: 100%;
    height: 40px;
    padding: 8px 12px 8px 40px;
    font-size: 16px;
    background-color: transparent;
    border: 1px solid #ffbb96;
    // border-radius: 8px;
    color: white;
    animation: ${colorChange} 6s infinite;
    // &::placeholder {
    //   color: white;
    // }
    &:focus {
      outline: none;
      background-color: transparent;
    }
    &:hover {
      background-color: transparent;
    }
  `,
};

const InputField = ({ placeholder = "Ask Max" }) => {
  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper}>
        <MagicIcon className={styles.magicIcon} width="2rem" height="2rem" />
        <Input placeholder={placeholder} className={styles.inputField} />
      </div>
    </div>
  );
};

export default InputField;
